import { render, staticRenderFns } from "./SpaceSettingsEditModalTemplate.vue?vue&type=template&id=7032adaf&scoped=true&"
import script from "./SpaceSettingsEditModalTemplate.vue?vue&type=script&lang=js&"
export * from "./SpaceSettingsEditModalTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SpaceSettingsEditModalTemplate.vue?vue&type=style&index=0&id=7032adaf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7032adaf",
  null
  
)

export default component.exports